import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  none: () => ({
    defaultColor: '',
    root: '',
    a: '',
    p: '',
    span: '',
    ul: '',
    li: '',
  }),
  'text-brand-1': color => ({
    defaultColor: COLORS.WHITE,
    root: `reset-heading font-brand leading-tight text-2xl lg:text-4xl ${
      color === COLORS.WHITE ? 'text-shadow-2' : ''
    }`,
    a: 'text-turquoise focus:turquoise-active hover:turquoise-active transition-color',
    p: 'mt-0 mb-4',
    span: 'mt-0 mb-4',
    ul: 'm-0 mb-4 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-1': () => ({
    defaultColor: COLORS.GRAY_DARKER,
    root: 'leading-normal text-base',
    a: 'text-blue focus:turquoise hover:turquoise transition-color underline',
    p: 'mt-0 mb-3',
    span: 'mt-0 mb-3',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-2': () => ({
    defaultColor: COLORS.GRAY_MEDIUM,
    root: 'leading-normal text-sm',
    a: 'text-blue focus:turquoise hover:turquoise transition-color underline',
    p: 'mt-0 mb-3',
    span: 'mt-0 mb-3',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-3': () => ({
    defaultColor: COLORS.GRAY_DARKER,
    root: 'leading-normal text-md',
    a: 'text-blue focus:turquoise hover:turquoise transition-color underline',
    p: 'mt-0 mb-3',
    span: 'mt-0 mb-3',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-4': () => ({
    defaultColor: COLORS.BLUE,
    root: 'leading-tight text-xl',
    a: 'text-turquoise focus:turquoise-active hover:turquoise-active transition-color underline',
    p: 'mt-0 mb-3',
    span: 'mt-0 mb-3',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-5': color => ({
    defaultColor: COLORS.WHITE,
    root: `reset-heading leading-tight text-md lg:text-xl ${
      color === COLORS.WHITE ? 'text-shadow-2' : ''
    }`,
    a: 'text-turquoise focus:turquoise-active hover:turquoise-active transition-color',
    p: 'mt-0 mb-3',
    span: 'mt-0 mb-3',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-6': color => ({
    defaultColor: COLORS.ORANGE,
    root: `reset-heading leading-tight text-s ${color === COLORS.ORANGE ? 'text-shadow-2' : ''}`,
    a: 'text-turquoise focus:turquoise-active hover:turquoise-active transition-color',
    p: 'mt-0 mb-3',
    span: 'mt-0 mb-3',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
  'text-sans-7': () => ({
    defaultColor: COLORS.GRAY_DARKER,
    root: 'leading-normal text-base',
    a: 'text-blue focus:turquoise hover:turquoise transition-color underline',
    p: 'mt-0',
    span: 'mt-0',
    ul: 'm-0 mb-3 list-none p-0',
    li: 'm-0 list-disc',
  }),
};
